export const API_URL = "https://api.woodandwashi.eu";
export const AUTH_URL = "https://services.woodandwashi.eu/nav";
